import React from 'react';
import * as S from './styles';

export default function PopUp() {
	return (
		<S.container>
			<h1>PopUp</h1>
		</S.container>
	);
}
